import { render, staticRenderFns } from "./resourceStoreUseRecordManageList.vue?vue&type=template&id=2fbe9eaf&scoped=true"
import script from "./resourceStoreUseRecordManageList.vue?vue&type=script&lang=js"
export * from "./resourceStoreUseRecordManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreUseRecordManageList.vue?vue&type=style&index=0&id=2fbe9eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe9eaf",
  null
  
)

export default component.exports